const SET_IMAGE = 'react-template/app/SET_IMAGE'

const initialState = {}

export default function images(state = initialState, action = {}) {
  switch (action.type) {
    case SET_IMAGE:
      return {
        ...state.images,
        [action.image.imageUrl]: {
          imageLocalUrl: action.image.imageLocalUrl,
          loading: action.image.loading,
        }
      }
    default:
      return state
  }
}

export function setImage(image) {
  return {
    type: SET_IMAGE,
    image
  }
}
